import { Channel } from 'client/model/skill';

import { InstallableAppsMeta } from '../types';

import { createContext } from './utils';

export interface WithAppsMetaInfo {
    appsMetaInfo: InstallableAppsMeta;
    handleAppCreation: (channel: Channel) => Promise<void>;
}

const {
    Provider,
    withContext: withAppsMetaInfo,
    Context,
} = createContext<WithAppsMetaInfo>({
    appsMetaInfo: {
        maxAppsPerUser: 0,
        targetPlatformsByChannel: {},
        categories: [],
        ageRestrictions: [],
    },
    handleAppCreation: async (_channel) => {},
});

export { Provider, withAppsMetaInfo, Context };
